import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-control-question-answer',
    templateUrl: './control-question-answer.component.html',
    styleUrls: ['./control-question-answer.component.scss'],
    standalone: false
})
export class ControlQuestionAnswerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
